
document.addEventListener("DOMContentLoaded", function () {
    
    /**
     * Reusable Slider Function
     * @param {string} containerSelector - The section containing the slider (e.g., '.variations-section')
     * @param {string} contentSelector - The class of the slides (e.g., '.tab-content')
     * @param {string} tabSelector - The class of the top menu tabs (e.g., '.tab-btn')
     * @param {string} nextBtnClass - The class of the next button
     * @param {string} prevBtnClass - The class of the prev button
     * @param {string} currentSpanClass - The class of the current number span
     * @param {string} totalSpanClass - The class of the total number span
     */
    function setupSlider(containerSelector, contentSelector, tabSelector, nextBtnClass, prevBtnClass, currentSpanClass, totalSpanClass) {
        // FIND THE CONTAINER FIRST
        const container = document.querySelector(containerSelector);
        if (!container) return; // Exit if container not found

        // SEARCH ONLY INSIDE THIS CONTAINER
        const slides = container.querySelectorAll(contentSelector);
        const tabs = container.querySelectorAll(tabSelector);
        const nextButtons = container.querySelectorAll(nextBtnClass);
        const prevButtons = container.querySelectorAll(prevBtnClass);
        const currentSpans = container.querySelectorAll(currentSpanClass);
        const totalSpans = container.querySelectorAll(totalSpanClass);

        let currentIndex = 0;
        const totalSlides = slides.length;

        // Initialize Total Count
        totalSpans.forEach(span => span.textContent = totalSlides);

        function updateView(index) {
            if (index < 0) index = 0;
            if (index >= totalSlides) index = totalSlides - 1;
            currentIndex = index;

            // 1. Update Slide Visibility
            slides.forEach((slide, i) => {
                slide.classList.toggle("active", i === currentIndex);
                slide.style.display = (i === currentIndex) ? "flex" : "none";
            });

            // 2. Update Tab Highlighting
            tabs.forEach((tab, i) => {
                tab.classList.toggle("active", i === currentIndex);
                if(tab.hasAttribute('aria-selected')) {
                    tab.setAttribute("aria-selected", i === currentIndex ? "true" : "false");
                }
            });

            // 3. Update Counter
            currentSpans.forEach(span => span.textContent = currentIndex + 1);

            // 4. Update Button States (Using visibility/display as per your requirement)
            prevButtons.forEach(btn => {
                btn.style.display = (currentIndex === 0) ? "none" : "block";
            });
            nextButtons.forEach(btn => {
                btn.style.display = (currentIndex === totalSlides - 1) ? "none" : "block";
            });
        }

        // Event: Next Button (Only for buttons inside THIS container)
        nextButtons.forEach(btn => {
            btn.addEventListener("click", (e) => {
                e.preventDefault();
                updateView(currentIndex + 1);
            });
        });

        // Event: Previous Button (Only for buttons inside THIS container)
        prevButtons.forEach(btn => {
            btn.addEventListener("click", (e) => {
                e.preventDefault();
                updateView(currentIndex - 1);
            });
        });

        // Event: Tab Clicks (Only for tabs inside THIS container)
        tabs.forEach((tab, index) => {
            tab.addEventListener("click", (e) => {
                e.preventDefault();
                updateView(index);
            });
        });

        // Initial State
        updateView(0);
    }

    // ==========================================
    // ACTIVATE SLIDER 1: Variations Section
    // ==========================================
    setupSlider(
        '.variations-section',    // <--- Added container scope
        '.tab-content',           
        '.tab-btn',               
        '.attachment-next',       
        '.attachment-prev',       
        '.attachment-current',    
        '.attachment-total'       
    );

    // ==========================================
    // ACTIVATE SLIDER 2: Recommended Attachments Section
    // ==========================================
    setupSlider(
        '.attachments-section',   // <--- Added container scope
        '.attachment-content',    
        '.attachment-tab',        
        '.attachment-next',       
        '.attachment-prev',       
        '.attachment-current',    
        '.attachment-total'       
    );
});

